export const TARGET_THUMBNAIL_WIDTH = 116;
export const THUMBNAIL_MARGIN_RIGHT = 12;

export const THUMBNAIL_RENDERED_WIDTH = 300;
export const THUMBNAIL_RENDERED_HEIGHT = 200;
